import { render } from "./DamageProductManagement.vue?vue&type=template&id=098e6eb7&scoped=true"
import script from "./DamageProductManagement.vue?vue&type=script&lang=js"
export * from "./DamageProductManagement.vue?vue&type=script&lang=js"

import "./DamageProductManagement.vue?vue&type=style&index=0&id=098e6eb7&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098e6eb7"]])

export default __exports__